import React from "react";
import { BackgroundImage, Image as RImage } from "rebass";
import ProgressiveImage from "react-progressive-image-loading";
import componentQueries from "react-component-queries";
// import { lazyload } from "react-lazyload";
import { compose } from "redux";
import styled from "styled-components";

const Container = styled.div`
  width: ${({ w }) => w};
  ${({ css }) => css};
`;

export const ResponsiveImage = compose(
  // lazyload({
  //   once: true,
  //   offset: 200
  // }),
  componentQueries(size => {
    const { width } = size;
    return {
      width
    };
  })
)(props => {
  const { src, w, background, containerCSS, ...rest } = props;
  const { width } = props;
  const full = `${src}w=${width + 50}`;
  const preview = `${src}w=100`;
  return (
    <Container css={containerCSS || ""} w={w || "100%"}>
      <ProgressiveImage
        preview={preview}
        src={full}
        render={(pSrc, style) => {
          if (background) {
            return <BackgroundImage {...rest} style={style} src={pSrc} />;
          }
          return <RImage {...rest} w="100%" style={style} src={pSrc} />;
        }}
      />
    </Container>
  );
});

export default props => {
  const { file, ...rest } = props;
  return <ResponsiveImage {...rest} src={file.url} />;
};



// WEBPACK FOOTER //
// ./src/components/image.js